import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { TextboxComponent } from "./textbox.component";

@NgModule({
  imports: [
    CommonModule,
    InputTextModule,
    ReactiveFormsModule,
  ],
  declarations: [
    TextboxComponent,
  ],
  entryComponents: [
    TextboxComponent,
  ],
  exports: [
    TextboxComponent,
  ],
})
export class TextboxModule { }
